import { render, staticRenderFns } from "./Border.vue?vue&type=template&id=3eec3f8d&scoped=true&"
import script from "./Border.vue?vue&type=script&lang=js&"
export * from "./Border.vue?vue&type=script&lang=js&"
import style0 from "./Border.vue?vue&type=style&index=0&id=3eec3f8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec3f8d",
  null
  
)

export default component.exports